module.exports = __webpack_public_path__ + "static/media/invest2.0cefd0c7.svg";